export default "__VITE_ASSET__CWvDxT5n__"